const ptBR = {
  // Common
  app_name: "JMS ERP",
  loading: "Carregando…",
  save: "Salvar",
  cancel: "Cancelar",
  edit: "Editar",
  delete: "Excluir",
  add: "Adicionar",
  search: "Buscar",
  actions: "Ações",
  confirm_delete: "Tem certeza que deseja excluir?",
  yes: "Sim",
  no: "Não",
  optional: "opcional",
  status: "Status",
  active: "Ativo",
  inactive: "Inativo",
  filter: "Filtrar",
  clear: "Limpar",
  all: "Todos",

  // Auth
  login_title: "Acesse sua conta",
  login_subtitle: "Gerencie clientes, serviços e pagamentos com clareza.",
  email: "E-mail",
  password: "Senha",
  sign_in: "Entrar",
  signing_in: "Entrando…",
  invalid_credentials: "E-mail ou senha inválidos",
  logout: "Sair",

  // Sidebar
  nav_dashboard: "Painel",
  nav_customers: "Clientes",
  nav_services: "Serviços",
  nav_payments: "Pagamentos",
  nav_balance: "Saldo",
  nav_documents: "Documentos",
  nav_appointments: "Agendamento",
  nav_settings: "Configurações",

  // Dashboard
  total_customers: "Total de Clientes",
  total_services: "Total de Serviços",
  total_payments: "Total de Pagamentos",
  outstanding_balance: "Saldo Devedor",
  recent_payments: "Pagamentos Recentes",
  no_recent_payments: "Nenhum pagamento recente.",
  amount: "Valor",
  method: "Método",
  date: "Data",

  // Customers
  customers_title: "Clientes",
  customers_subtitle: "Gerencie seus clientes e informações de contato.",
  full_name: "Nome Completo",
  phone: "Telefone",
  whatsapp: "WhatsApp",
  address: "Endereço",
  notes: "Observações",
  add_customer: "Novo Cliente",
  edit_customer: "Editar Cliente",
  no_customers: "Nenhum cliente cadastrado.",

  // Services
  services_title: "Serviços",
  services_subtitle: "Cadastre os serviços oferecidos pela sua empresa.",
  service_name: "Nome do Serviço",
  description: "Descrição",
  price: "Preço",
  add_service: "Novo Serviço",
  edit_service: "Editar Serviço",
  no_services: "Nenhum serviço cadastrado.",

  // Payments
  payments_title: "Pagamentos",
  payments_subtitle: "Registre os pagamentos e acompanhe o saldo restante.",
  customer: "Cliente",
  service: "Serviço",
  service_price: "Preço do Serviço",
  amount_paid: "Valor Pago",
  payment_date: "Data do Pagamento",
  payment_method: "Método de Pagamento",
  remaining_balance: "Saldo Restante",
  add_payment: "Novo Pagamento",
  edit_payment: "Editar Pagamento",
  no_payments: "Nenhum pagamento registrado.",
  method_cash: "Dinheiro",
  method_pix: "PIX",
  method_bank: "Transferência",
  method_card: "Cartão",
  select_customer: "Selecione um cliente",
  select_service: "Selecione um serviço",
  select_method: "Selecione um método",

  // Balance
  balance_title: "Saldo",
  balance_subtitle: "Visão consolidada de pagamentos e saldos por cliente e serviço.",
  total_price: "Preço Total",
  total_paid: "Total Pago",
  only_pending: "Somente pendentes",
  no_balance: "Nenhum saldo para exibir.",

  // Settings
  settings_title: "Configurações",
  settings_subtitle: "Preferências da empresa e do usuário.",
  company_settings: "Empresa",
  company_name: "Nome da Empresa",
  company_logo: "URL do Logotipo",
  currency: "Moeda",
  language: "Idioma",
  user_profile: "Perfil do Usuário",
  name: "Nome",
  current_password: "Senha Atual",
  new_password: "Nova Senha",
  update_profile: "Atualizar Perfil",
  update_company: "Atualizar Empresa",
  saved_successfully: "Salvo com sucesso",

  // Toasts
  created: "Criado com sucesso",
  updated: "Atualizado com sucesso",
  deleted: "Excluído com sucesso",
  error_generic: "Ocorreu um erro. Tente novamente.",

  // AP-165 Fase 2 · Services
  svc_pricing_type: "Tipo de Cobrança",
  svc_per_service: "Cobrado por Serviço",
  svc_per_unit: "Cobrado por Unidade",
  svc_per_time: "Cobrado por Tempo",
  svc_hint_per_unit: "O cliente compra várias unidades (ex.: fotocópia, foto 3x4).",
  svc_hint_per_time: "Cobrado por duração (ex.: consultoria por hora).",
  svc_hint_per_service: "Valor fixo por serviço.",
  svc_unit_label: "Unidade de Medida",
  svc_unit_ph_time: "Hora",
  svc_unit_ph_unit: "Página, Cópia, Foto…",
  svc_price_per_unit: "Preço por Unidade",
  svc_price_per_hour: "Valor por Hora",

  // AP-165 Fase 2 · Customers
  cus_view: "Ver:",
  cus_visible: "Visíveis",
  cus_hidden: "Ocultos",
  cus_contact: "Contato",
  cus_hidden_badge: "Cliente Oculto",
  cus_open: "Abrir",
  cus_show: "Mostrar cliente",
  cus_hide: "Esconder cliente",
  cus_delete_title: "Excluir Cliente",
  cus_delete_desc_1: "O cliente {name} será removido da lista principal, porém todos os seus dados permanecerão armazenados no sistema.",
  cus_delete_desc_2: "O Master poderá restaurá-lo posteriormente pela Lixeira.",
  cus_delete_confirm_q: "Deseja continuar?",
  cus_attention: "ATENÇÃO",
  cus_show_title: "Mostrar Cliente",
  cus_show_desc: "Deseja restaurar o cliente {name} à visão de todos os usuários autorizados?",
  cus_hide_desc: "Deseja ocultar o cliente {name}? Todos os dados permanecerão salvos. O cliente apenas deixará de aparecer para os usuários comuns.",
  cus_hide_reason_label: "Motivo (opcional)",
  cus_hide_reason_ph: "Ex.: Cliente arquivado, revisão interna…",
  cus_btn_show: "Mostrar",
  cus_btn_hide: "Esconder",

  // AP-165 Fase 2 · Payments
  pay_combobox_placeholder: "Buscar por nome, CPF, WhatsApp, e-mail ou processo…",
  pay_combobox_search_ph: "Digite para buscar…",
  pay_combobox_searching: "Buscando…",
  pay_combobox_empty: "Nenhum cliente encontrado.",
  pay_discount_promocao_jms: "Promoção JMS",
  pay_discount_desconto_comercial: "Desconto Comercial",
  pay_discount_cliente_fidelizado: "Cliente Fidelizado",
  pay_discount_ajuste_preco: "Ajuste de Preço",
  pay_discount_campanha_especial: "Campanha Especial",
  pay_discount_outro: "Outro",
};

export default ptBR;
